import React, { useCallback, useMemo } from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton, Icon } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { purple } from '../../../utils/colors'

const SubOptionsDialog = ({ open, onClose, title = '', description = '', children, numberOfOptions = 1 }) => {
	const classes = useStyles()

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	// same logic as in OptionsMenu.js
	const rowCount = useMemo(() => {
		if (numberOfOptions === 5) {
			return 3
		}
		if (numberOfOptions % 3 === 0) {
			return 3
		}
		if (numberOfOptions % 4 === 0) {
			return 4
		}
		if (numberOfOptions % 5 === 0) {
			return 5
		}

		return 4
	}, [numberOfOptions])

	const dialogWidth = Math.ceil(numberOfOptions / rowCount) * 350

	return (
		<Dialog
			open={open}
			onClose={handleOnClose}
			PaperProps={{
				style: {
					maxWidth: dialogWidth,
					width: dialogWidth,
					padding: 0
				}
			}}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.iconContainer}>
						<Icon className={`fas fa-plus-circle ${classes.infoIcon}`} />
					</div>
					<div className={classes.titleContainer}>{title}</div>
					{onClose ? (
						<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
							<Close onClick={handleOnClose} />
						</IconButton>
					) : null}
				</div>
			</DialogTitle>
			<DialogContent className={classes.sectionPadding}>
				<div>{description}</div>
				<div>{children}</div>
			</DialogContent>
		</Dialog>
	)
}

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '1.1rem 1.5rem',
		gap: '.8rem'
	},
	sectionPadding: {
		padding: '1.5rem',
		paddingTop: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: '1rem'
	},
	titleContainer: {
		flex: 1,
		fontFamily: 'Nunito',
		fontSize: '1rem'
	},
	iconContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	infoIcon: {
		fontSize: '1.1rem',
		color: purple[500],
		overflow: 'unset',
		display: 'flex',
		justifyContent: 'center',
		position: 'relative',
		top: '1px'
	}
}))

export default SubOptionsDialog
